<template>
  <loader :is-loading="isLoading" v-resize="onResize">
    <div>
      <v-list-item two-line class="px-0">
        <v-list-item-avatar class="mt-2">
          <v-icon color="primary" large>{{ icon }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <div class="d-flex justify-space-between font-weight-bold">
              {{ title || generateMessage('boilerplate.filters.title') }}
              <slot name="action-title" />
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            <truncate-text-with-hover
              class="font-classic"
              :text="subtitle"
              :length="25"
            />
            <slot name="subtitle" />
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-btn
        block
        class="text-none my-2"
        @click="resetFilters()"
        color="primary"
        text
        v-if="resetBtn"
      >
        <v-icon>{{ generateMessage('boilerplate.icons.refresh') }}</v-icon>
        <span class="text-decoration-underline">
          {{ generateMessage('boilerplate.filters.reset') }}
        </span>
      </v-btn>
      <custom-page-selector
        v-if="namespace && isPagination"
        :namespace="namespace"
      />
      <v-text-field
        v-if="isSearch"
        v-model.trim="search"
        :label="generateMessage('boilerplate.filters.search')"
        class="my-2"
        outlined
        dense
        clearable
        prepend-inner-icon="mdi-magnify"
      >
        <template v-slot:append>
          <v-menu
            offset-y
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" x-small icon outlined>
                <v-icon>
                  {{ generateMessage('boilerplate.filters.icons.infos') }}
                </v-icon>
              </v-btn>
            </template>
            <div class="background pa-2">
              {{ generateMessage('boilerplate.filters.searchIn') }}
              <ul>
                <li v-for="field in searchFields" :key="field">
                  {{
                    generateMessage(`${i18nPath || namespace}.fields.${field}`)
                  }}
                </li>
              </ul>
            </div>
          </v-menu>
        </template>
      </v-text-field>
      <div style="height: 36px" v-if="isDateFilter && namespace">
        <filter-by-date
          block
          text
          type="datetime-local"
          :namespace="namespace"
        />
      </div>
      <v-divider class="mb-3" />
    </div>
    <div
      class="overflow-y-auto overflow-x-hidden mt-2"
      :style="`height: ${height}px`"
    >
      <slot name="content" />
    </div>
  </loader>
</template>

<script>
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';
import FilterByDate from '@/components/boilerplate/RightSideBar/FilterByDate';
import { generateMessage } from '@/utils/i18n';
import Loader from '@/components/widgets/Loader';
import resizable from '@/business/mixins/resizable';

export default {
  name: 'CustomDrawer',
  mixins: [resizable],
  components: {
    CustomPageSelector,
    FilterByDate,
    Loader,
    TruncateTextWithHover,
  },
  props: {
    icon: { type: String, required: true },
    isDateFilter: { type: Boolean, required: false },
    isLoading: { type: Boolean, required: false },
    isPagination: { type: Boolean, required: false },
    isSearch: { type: Boolean, required: false },
    i18nPath: { type: String, required: false },
    namespace: { type: String, required: false },
    resetBtn: { type: Boolean, required: false, default: true },
    subtitle: { type: String, required: false },
    title: { type: String, required: false },
  },
  computed: {
    search: {
      get() {
        return this.$store.getters[`${this.namespace}/globalSearch`];
      },
      set(val) {
        this.$store.dispatch(`${this.namespace}/setGlobalSearch`, val);
      },
    },
    searchFields: {
      get() {
        return this.$store.getters[`${this.namespace}/searchAttributesArray`];
      },
    },
    height() {
      const titleHeight = 75;
      const resetHeight = 44;
      const paginationHeight = 28;
      const searchHeight = 66;
      const dateFilterHeight = 36;
      let calculatedHeight = titleHeight + resetHeight;
      if (this.isDateFilter) calculatedHeight += dateFilterHeight;
      if (this.isSearch) calculatedHeight += searchHeight;
      if (this.namespace && this.isPagination)
        calculatedHeight += paginationHeight;
      return this.contentHeightSideBar - calculatedHeight - 30;
    },
  },
  methods: {
    generateMessage,
    resetFilters() {
      this.$store.dispatch(`${this.namespace}/clearFilters`);
    },
  },
};
</script>
